import { Col, Row } from 'antd';
import { IApprovalDetail } from 'interface/portfolio.interface';
import { IUser } from 'interface/user.interface';

interface IProps {
  info?: number;
  approvalInfo?: IApprovalDetail[];
  subInfo?: number;
}
const APPROVE_STAGE = [
  { key: undefined, value: '' },
  { key: 1, value: '1. Phát hành danh mục' },
  { key: 2, value: '2. Chi nhánh đăng ký mẫu' },
  { key: 3, value: '3. Đăng ký giỏ hàng danh mục' },
];
const APPROVE_SUB_STAGE = [
  { key: 1, value: 'A. Chi nhánh (Chỉ phê duyệt đơn thuộc chi nhánh)' },
  { key: 2, value: 'B. Hội sở' },
];
const APPROVE_TYPE = [
  { key: 0, value: 'Đồng cấp' },
  { key: 1, value: 'Tuần tự' },
];
const getName = (value: IUser[]) => {
  let res = '';
  value.forEach((item) => {
    res += item.fullName + '; ';
  });
  return res;
};
export default function ApproveInfo(Props: IProps): JSX.Element {
  const approvalInfo = Props.approvalInfo || undefined;
  const stageInfo = Props.info || undefined;
  const stageSubInfo = Props.subInfo || undefined;

  return (
    <>
      {approvalInfo && (
        <div className="mt-4">
          <div
            className="text-primary-50"
            style={{ fontSize: '18px', fontWeight: 'bold' }}
          >
            {APPROVE_STAGE.find((item) => item.key === stageInfo)?.value}
          </div>
          <br />
          <div
            className="text-black-50"
            style={{ fontSize: '18px', fontWeight: 'bold' }}
          >
            {APPROVE_SUB_STAGE.find((item) => item.key === stageSubInfo)?.value}
          </div>
          <>
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className="mb-1 mt-4"
              justify="start"
            >
              <Col span={4} className="">
                <div className="text-sm font-semibold text-neutral-70">
                  <div>Cấp phê duyệt</div>
                </div>
              </Col>
              <Col span={4} className="">
                <div className="text-sm font-semibold text-neutral-40">
                  <span className="mr-[1px]">:</span> {approvalInfo.length}
                </div>
              </Col>
              <Col span={4} className="">
                <div className="text-sm font-semibold text-neutral-70">
                  <div>Thời gian phê duyệt</div>
                </div>
              </Col>
              <Col span={4} className="">
                <div className="text-sm font-semibold text-neutral-40">
                  <span className="mr-[1px]">:</span>
                  {approvalInfo?.slice(0, 1)[0].date_end || '-'} ngày
                </div>
              </Col>
              {/* <Col span={4} className="">
                <div className="text-sm font-semibold text-neutral-70">
                  <div>Loại phê duyệt</div>
                </div>
              </Col>
              <Col span={4} className="">
                <div className="text-sm font-semibold text-neutral-40">
                  <span className="mr-[1px]">:</span>{' '}
                  {
                    APPROVE_TYPE.find(
                      (item) =>
                        item.key === approvalInfo?.slice(0, 1)[0].approve_type
                    )?.value
                  }
                </div>
              </Col> */}
            </Row>
            {approvalInfo.map((item, index) => (
              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify="start"
                className="mb-1 mt-4"
                key={Math.random()}
              >
                <Col span={4} className="">
                  <div className="text-sm font-semibold text-neutral-70">
                    <div>Người phê duyệt cấp {index + 1}</div>
                  </div>
                </Col>
                <Col span={20} className="">
                  <div className="text-sm font-semibold text-neutral-40">
                    <span className="mr-[1px]">:</span>
                    {getName(item.list_user)}
                  </div>
                </Col>
              </Row>
            ))}
          </>
        </div>
      )}
    </>
  );
}
